import Constants from "../../Action/Constants";
import Translator from "../../Translation/Translator";
import { ActionInterface } from "../../Interface/ActionInterface";

interface StateInterface {
  files: any;
  error: boolean;
  fields: string[];
  translatedMessage: string;
  defaultFile: any;
}

const initialState: StateInterface = {
  files: {},
  error: false,
  fields: [],
  translatedMessage: "",
  defaultFile: {
    state: 1,
    dialogOpen: false,
    disableButton: true,
    title: "",
    total: 0,
    current: 0,
    max: 100,
    progress: 0,
    paymentIds: [],
    linked: 0,
    translatedMessage: "",
    createdPayments: 0,
    message: ""
  }
};

export const bankTransactionsReducer = (
  state: StateInterface = initialState,
  action: ActionInterface
): StateInterface => {
  switch (action.type) {
    case Constants.GLOBAL_TRANSACTION_FILE_UPLOAD_SUCCESS:
      {
        const transactionFileId = action.payload?.transactionFileId;
        const files = {...state.files};
        const filesIds = Object.keys(state?.files || {});

        if (!filesIds.includes(transactionFileId)) {
          files[transactionFileId] = {...state.defaultFile};
        }

        return {
          ...state,
          files: {...files}
        };
      }

    case Constants.GLOBAL_TRANSACTION_FILE_UPLOAD_FAILURE:
      return {
        ...state,
        error: true,
        translatedMessage: action.payload?.err.translatedMessage
      };

    case Constants.GLOBAL_TRANSACTION_FILE_UPDATE_FAILURE:
      return {
        ...state,
        fields: action.payload?.err.fields || [],
        translatedMessage: action.payload?.err.translatedMessage
      };

    case Constants.PAGE_BANK_TRANSACTIONS_PROGRESS:
      {
        const fileId = action.payload?.id;
        const files = {...state.files};

        if (!!files[fileId]) {
          files[fileId]['state'] = action.payload?.total === action.payload?.current ? 3 : 2;
          files[fileId]['total'] = action.payload?.total;
          files[fileId]['current'] = action.payload?.current;
          files[fileId]['countOfExistingPayments'] = action.payload?.countOfExistingPayments;
          files[fileId]['countOfCreatedPayments'] = action.payload?.countOfCreatedPayments;
          files[fileId]['countOfNotRecognizedPayments'] = action.payload?.countOfNotRecognizedPayments;
          files[fileId]['title'] = action.payload?.total === action.payload?.current ? Translator.trans("label-done") : Translator.trans("processing");
          files[fileId]['disableButton'] = action.payload?.total === action.payload?.current ? false : true;
        }
        return {
          ...state,
          files: {...files},
          translatedMessage: ""
        };
      }

    case Constants.PAGE_BANK_TRANSACTIONS_CLEAR:
    case Constants.AUTH_SIGNOUT:
      return {
        ...initialState
      };

    default:
      return state;
  }
};
